import { all } from "redux-saga/effects";
import {
  alternativeItemsListWatcher,
  alternativerItemImportWatcher,
  addCustomInvoiceWatcher,
  currentPrintPreferenceeWatcher,
  deleteAlternativeTransWatcher,
  documentNumberingListWatcher,
  documentNumberingSeriesAddWatcher,
  documentNumberingSeriesListWatcher,
  documentNumberingSeriesUpdateWatcher,
  documentNumberingUpdateWatcher,
  itemCategoryAddWatcher,
  itemCategoryDeleteWatcher,
  itemCategoryImportWatcher,
  itemCategoryListWatcher,
  itemCategoryUpdateWatcher,
  itemGroupAddWatcher,
  itemGroupDeleteWatcher,
  itemGroupImportWatcher,
  itemGroupListWatcher,
  itemGroupUpdateWatcher,
  itemTypeAddWatcher,
  itemTypeDeleteWatcher,
  itemTypeImportWatcher,
  itemTypeListWatcher,
  itemTypeUpdateWatcher,
  manufacturerAddWatcher,
  manufacturerDeleteWatcher,
  manufacturerImportWatcher,
  manufacturerTableListWatcher,
  manufacturerUpdateWatcher,
  mapAlternativerItemWatcher,
  paytmAddWatcher,
  paytmUpdateWatcher,
  paytmViewWatcher,
  phonepeAddWatcher,
  phonepeUpdateWatcher,
  phonepeViewWatcher,
  pineLabsAddWatcher,
  pineLabsUpdateWatcher,
  pineLabsViewWatcher,
  printPreferenceListWatcher,
  printPreferenceUpdateWatcher,
  razorpayAddWatcher,
  razorpayUpdateWatcher,
  razorpayViewWatcher,
  shippingTypeAddWatcher,
  shippingTypeDeleteWatcher,
  shippingTypeImportWatcher,
  shippingTypeTableListWatcher,
  shippingTypeUpdateWatcher,
  smsAddWatcher,
  smsUpdateWatcher,
  smsViewWatcher,
  smtpAddWatcher,
  smtpUpdateWatcher,
  smtpViewWatcher,
  storeDetailsGetWatcher,
  storeDetailsUpdateWatcher,
  stripeAddWatcher,
  stripeUpdateWatcher,
  stripeViewWatcher,
  taxCombinationAddWatcher,
  taxCombinationDeleteWatcher,
  taxCombinationImportWatcher,
  taxCombinationItemDeleteWatcher,
  taxCombinationTableListWatcher,
  taxCombinationUpdateWatcher,
  taxTypeAddWatcher,
  taxTypeDeleteWatcher,
  taxTypeDropDownWatcher,
  taxTypeImportWatcher,
  taxTypeTableListWatcher,
  taxTypeUpdateWatcher,
  tcsTaxCreateWatcher,
  tcsTaxDeleteWatcher,
  tcsTaxImportWatcher,
  tcsTaxListWatcher,
  tdsTaxCreateWatcher,
  tdsTaxDeleteWatcher,
  tdsTaxImportWatcher,
  tdsTaxListWatcher,
  templateCreateWatcher,
  templateDeleteWatcher,
  templateEditWatcher,
  templateTableWatcher,
  templateViewWatcher,
  uomCreateWatcher,
  uomGroupDataAddWatcher,
  uomGroupDataListWatcher,
  uomGroupDataUpdateWatcher,
  uomGroupDeleteWatcher,
  uomGroupImportWatcher,
  uomGroupItemDeleteWatcher,
  uomGroupItemImportWatcher,
  uomGroupUomListWatcher,
  uomGroupCalculationWatcher,
  uomImportWatcher,
  uomListWatcher,
  uomUpdateWatcher,
  whatsappAddWatcher,
  whatsappUpdateWatcher,
  whatsappViewWatcher,
  BillTypesWatcher,
  customNumberingListWatcher,
  customNumberingUpdateWatcher,
  customNumberingSeriesListWatcher,
  customNumberingSeriesAddWatcher,
  customNumberingSeriesUpdateWatcher,
  roleCreateWatcher,
  roleEditWatcher,
  roleDeleteWatcher,
  roleDocumentUploadWatcher,
  departmentCreateWatcher,
  departmentEditWatcher,
  departmentDeleteWatcher,
  departmentDocumentUploadWatcher,
  attachedRolesDepartmentCreateWatcher,
  attachedRolesDepartmentDeleteWatcher,
  roleSearchWatcher,
  departmentSearchWatcher,
  moduleSettingsGetAllWatcher,
  moduleSettingsUpdateWatcher,
  partyListWatcher,
  drugSearchWatcher,
  drugCreateWatcher,
  drugEditWatcher,
  drugDeleteWatcher,
  drugDocumentUploadWatcher,
  genericSearchWatcher,
  genericCreateWatcher,
  genericEditWatcher,
  genericDeleteWatcher,
  genericDocumentUploadWatcher,
  compositionSearchWatcher,
  compositionCreateWatcher,
  compositionEditWatcher,
  compositionDeleteWatcher,
  compositionDocumentUploadWatcher,
  leadSearchWatcher,
  leadCreateWatcher,
  leadEditWatcher,
  leadDeleteWatcher,
  leadDocumentUploadWatcher,
  packingSearchWatcher,
  packingCreateWatcher,
  packingEditWatcher,
  packingDeleteWatcher,
  packingDocumentUploadWatcher,
  packingTypeSearchWatcher,
  packingTypeCreateWatcher,
  packingTypeEditWatcher,
  packingTypeDeleteWatcher,
  packingTypeDocumentUploadWatcher,
  cartonSearchWatcher,
  cartonCreateWatcher,
  cartonEditWatcher,
  cartonDeleteWatcher,
  cartonDocumentUploadWatcher,
  paymentSearchWatcher,
  paymentCreateWatcher,
  paymentEditWatcher,
  paymentDeleteWatcher,
  paymentDocumentUploadWatcher,
  partySearchWatcher,
  partyCreateWatcher,
  partyEditWatcher,
  partyDeleteWatcher,
  partyDocumentUploadWatcher,
  partyCategorySearchWatcher,
  partyCategoryCreateWatcher,
  partyCategoryEditWatcher,
  partyCategoryDeleteWatcher,
  partyCategoryDocumentUploadWatcher,
  partyGroupSearchWatcher,
  partyGroupCreateWatcher,
  partyGroupEditWatcher,
  partyGroupDeleteWatcher,
  partyGroupDocumentUploadWatcher,
  countrySearchWatcher,
  countryCreateWatcher,
  countryEditWatcher,
  countryDeleteWatcher,
  countryDocumentUploadWatcher,
  regionSearchWatcher,
  regionCreateWatcher,
  regionEditWatcher,
  regionDeleteWatcher,
  regionDocumentUploadWatcher,
  stateSearchWatcher,
  stateCreateWatcher,
  stateEditWatcher,
  stateDeleteWatcher,
  stateDocumentUploadWatcher,
  districtSearchWatcher,
  districtCreateWatcher,
  districtEditWatcher,
  districtDeleteWatcher,
  districtDocumentUploadWatcher,
  citySearchWatcher,
  cityCreateWatcher,
  cityEditWatcher,
  cityDeleteWatcher,
  cityDocumentUploadWatcher,
  areaSearchWatcher,
  areaCreateWatcher,
  areaEditWatcher,
  areaDeleteWatcher,
  areaDocumentUploadWatcher,
  specializationSearchWatcher,
  specializationCreateWatcher,
  specializationEditWatcher,
  specializationDeleteWatcher,
  specializationDocumentUploadWatcher,
  subSpecialSearchWatcher,
  subSpecialCreateWatcher,
  subSpecialEditWatcher,
  subSpecialDeleteWatcher,
  subSpecialDocumentUploadWatcher,
  insuranceSearchWatcher,
  insuranceCreateWatcher,
  insuranceEditWatcher,
  insuranceDeleteWatcher,
  insuranceDocumentUploadWatcher,
  uomGroupUomListNewWatcher,
} from "../settings-saga";

export default function* settingsRootSaga() {
  yield all([
    uomCreateWatcher(),
    uomUpdateWatcher(),
    uomListWatcher(),
    uomImportWatcher(),
    uomGroupDataListWatcher(),
    uomGroupDataAddWatcher(),
    uomGroupDataUpdateWatcher(),
    uomGroupDeleteWatcher(),
    uomGroupUomListWatcher(),
    uomGroupUomListNewWatcher(),

    uomGroupItemDeleteWatcher(),
    uomGroupImportWatcher(),
    uomGroupItemImportWatcher(),
    uomGroupCalculationWatcher(),
    itemTypeAddWatcher(),
    itemTypeUpdateWatcher(),
    itemTypeDeleteWatcher(),
    itemTypeImportWatcher(),
    itemTypeListWatcher(),
    itemCategoryAddWatcher(),
    itemCategoryUpdateWatcher(),
    itemCategoryDeleteWatcher(),
    itemCategoryListWatcher(),
    itemCategoryImportWatcher(),
    itemGroupAddWatcher(),
    itemGroupUpdateWatcher(),
    itemGroupDeleteWatcher(),
    itemGroupListWatcher(),
    itemGroupImportWatcher(),
    manufacturerAddWatcher(),
    manufacturerUpdateWatcher(),
    manufacturerDeleteWatcher(),
    manufacturerTableListWatcher(),
    manufacturerImportWatcher(),
    taxTypeAddWatcher(),
    taxTypeUpdateWatcher(),
    taxTypeDeleteWatcher(),
    taxTypeTableListWatcher(),
    taxTypeImportWatcher(),
    taxCombinationAddWatcher(),
    taxCombinationUpdateWatcher(),
    taxCombinationTableListWatcher(),
    taxTypeDropDownWatcher(),
    taxCombinationDeleteWatcher(),
    taxCombinationItemDeleteWatcher(),
    taxCombinationImportWatcher(),
    shippingTypeAddWatcher(),
    shippingTypeUpdateWatcher(),
    shippingTypeDeleteWatcher(),
    shippingTypeTableListWatcher(),
    shippingTypeImportWatcher(),

    documentNumberingListWatcher(),
    documentNumberingUpdateWatcher(),
    documentNumberingSeriesListWatcher(),
    documentNumberingSeriesAddWatcher(),
    documentNumberingSeriesUpdateWatcher(),
    customNumberingListWatcher(),
    customNumberingUpdateWatcher(),
    customNumberingSeriesListWatcher(),
    customNumberingSeriesAddWatcher(),
    customNumberingSeriesUpdateWatcher(),

    smtpViewWatcher(),
    smtpAddWatcher(),
    smtpUpdateWatcher(),
    whatsappViewWatcher(),
    whatsappAddWatcher(),
    whatsappUpdateWatcher(),
    smsViewWatcher(),
    smsAddWatcher(),
    smsUpdateWatcher(),

    roleCreateWatcher(),
    roleSearchWatcher(),
    roleEditWatcher(),
    roleDeleteWatcher(),
    roleDocumentUploadWatcher(),
    departmentCreateWatcher(),
    departmentSearchWatcher(),
    departmentEditWatcher(),
    departmentDeleteWatcher(),
    departmentDocumentUploadWatcher(),
    attachedRolesDepartmentCreateWatcher(),
    attachedRolesDepartmentDeleteWatcher(),

    drugSearchWatcher(),
    drugCreateWatcher(),
    drugEditWatcher(),
    drugDeleteWatcher(),
    drugDocumentUploadWatcher(),

    // Generic watchers
    genericSearchWatcher(),
    genericCreateWatcher(),
    genericEditWatcher(),
    genericDeleteWatcher(),
    genericDocumentUploadWatcher(),

    // Composition watchers
    compositionSearchWatcher(),
    compositionCreateWatcher(),
    compositionEditWatcher(),
    compositionDeleteWatcher(),
    compositionDocumentUploadWatcher(),

    // Lead watchers
    leadSearchWatcher(),
    leadCreateWatcher(),
    leadEditWatcher(),
    leadDeleteWatcher(),
    leadDocumentUploadWatcher(),

    // Payment watchers
    paymentSearchWatcher(),
    paymentCreateWatcher(),
    paymentEditWatcher(),
    paymentDeleteWatcher(),
    paymentDocumentUploadWatcher(),

    // 📦 Packing
    packingSearchWatcher(),
    packingCreateWatcher(),
    packingEditWatcher(),
    packingDeleteWatcher(),
    packingDocumentUploadWatcher(),

    // 📦 Packing Type
    packingTypeSearchWatcher(),
    packingTypeCreateWatcher(),
    packingTypeEditWatcher(),
    packingTypeDeleteWatcher(),
    packingTypeDocumentUploadWatcher(),

    // 📦 Carton
    cartonSearchWatcher(),
    cartonCreateWatcher(),
    cartonEditWatcher(),
    cartonDeleteWatcher(),
    cartonDocumentUploadWatcher(),

    // Party watchers
    partySearchWatcher(),
    partyCreateWatcher(),
    partyEditWatcher(),
    partyDeleteWatcher(),
    partyDocumentUploadWatcher(),

    partyCategorySearchWatcher(),
    partyCategoryCreateWatcher(),
    partyCategoryEditWatcher(),
    partyCategoryDeleteWatcher(),
    partyCategoryDocumentUploadWatcher(),

    partyGroupSearchWatcher(),
    partyGroupCreateWatcher(),
    partyGroupEditWatcher(),
    partyGroupDeleteWatcher(),
    partyGroupDocumentUploadWatcher(),

    //
    // Party Group

    // Country
    countrySearchWatcher(),
    countryCreateWatcher(),
    countryEditWatcher(),
    countryDeleteWatcher(),
    countryDocumentUploadWatcher(),

    // Region
    regionSearchWatcher(),
    regionCreateWatcher(),
    regionEditWatcher(),
    regionDeleteWatcher(),
    regionDocumentUploadWatcher(),

    // State
    stateSearchWatcher(),
    stateCreateWatcher(),
    stateEditWatcher(),
    stateDeleteWatcher(),
    stateDocumentUploadWatcher(),

    // District
    districtSearchWatcher(),
    districtCreateWatcher(),
    districtEditWatcher(),
    districtDeleteWatcher(),
    districtDocumentUploadWatcher(),

    // City
    citySearchWatcher(),
    cityCreateWatcher(),
    cityEditWatcher(),
    cityDeleteWatcher(),
    cityDocumentUploadWatcher(),

    // Area
    areaSearchWatcher(),
    areaCreateWatcher(),
    areaEditWatcher(),
    areaDeleteWatcher(),
    areaDocumentUploadWatcher(),

    //
    // Specialization watchers
    specializationSearchWatcher(),
    specializationCreateWatcher(),
    specializationEditWatcher(),
    specializationDeleteWatcher(),
    specializationDocumentUploadWatcher(),

    // Sub Special watchers
    subSpecialSearchWatcher(),
    subSpecialCreateWatcher(),
    subSpecialEditWatcher(),
    subSpecialDeleteWatcher(),
    subSpecialDocumentUploadWatcher(),

    // Insurance watchers
    insuranceSearchWatcher(),
    insuranceCreateWatcher(),
    insuranceEditWatcher(),
    insuranceDeleteWatcher(),
    insuranceDocumentUploadWatcher(),

    razorpayViewWatcher(),
    razorpayAddWatcher(),
    razorpayUpdateWatcher(),
    stripeViewWatcher(),
    stripeAddWatcher(),
    stripeUpdateWatcher(),
    phonepeViewWatcher(),
    phonepeAddWatcher(),
    phonepeUpdateWatcher(),
    paytmViewWatcher(),
    paytmAddWatcher(),
    paytmUpdateWatcher(),
    pineLabsViewWatcher(),
    pineLabsAddWatcher(),
    pineLabsUpdateWatcher(),

    printPreferenceListWatcher(),
    printPreferenceUpdateWatcher(),
    currentPrintPreferenceeWatcher(),

    storeDetailsGetWatcher(),
    storeDetailsUpdateWatcher(),

    deleteAlternativeTransWatcher(),
    alternativeItemsListWatcher(),
    mapAlternativerItemWatcher(),
    alternativerItemImportWatcher(),
    tcsTaxListWatcher(),
    addCustomInvoiceWatcher(),
    tcsTaxCreateWatcher(),
    tcsTaxDeleteWatcher(),
    tcsTaxImportWatcher(),
    tdsTaxListWatcher(),
    tdsTaxCreateWatcher(),
    tdsTaxDeleteWatcher(),
    tdsTaxImportWatcher(),
    partyListWatcher(),
    templateCreateWatcher(),
    templateTableWatcher(),
    templateViewWatcher(),
    templateEditWatcher(),
    templateDeleteWatcher(),
    BillTypesWatcher(),
    moduleSettingsGetAllWatcher(),
    moduleSettingsUpdateWatcher(),
  ]);
}
